// The loader (public/component.js) builds the iframe URL as
// `<host>/<jsversion>/<flow>/<config>`, so the iframe can read which loader
// version embedded it from the first path segment. Unversioned routes
// (`/<flow>/<config>`) have no version segment. Only a plain `1`, `1.2` or
// `1.2.3` is accepted; anything else is ignored.
const LOADER_VERSION_PATTERN = /^\d+(\.\d+){0,2}$/;

export function getLoaderVersion(pathname = window.location.pathname) {
  const segment = String(pathname || "").split("/")[1] || "";
  return LOADER_VERSION_PATTERN.test(segment) ? segment : undefined;
}

export const LOADER_VERSION_HEADER = "x-component-version";

// Request headers for every `Tools/init` call: `{ "x-component-version": v }`,
// or `{}` when the iframe was not loaded from a versioned URL.
export function loaderVersionHeaders(pathname) {
  const version = getLoaderVersion(pathname);
  return version ? { [LOADER_VERSION_HEADER]: version } : {};
}
